import { defineStore } from 'pinia'
import defaultTheme from 'tailwindcss/defaultTheme'
export const screenStore = defineStore('screen', {
    state: () => ({
        width: window.innerWidth,
        height: window.innerHeight,
        currentBreakpoint: null,
    }),

    getters: {
        /**
         * Returns the breakpoints that have not been reached yet
         * This can me use like the css breakpoints. eg. md:w-1/2 will be applied for all breakpoints greater than md
         * So this returns all breakpoints greater than the current one
         */
        remainingBreakpoints(state) {
            if (state.currentBreakpoint === null) {
                return Object.keys(defaultTheme.screens)
            }

            let breakpoints = Object.keys(defaultTheme.screens)
            // Get the index of the current breakpoint and return the keys after it
            return breakpoints.slice(
                breakpoints.findIndex(
                    (breakpoint) => breakpoint === state.currentBreakpoint
                ) + 1
            )
        },

        /**
         *
         * Returns the breakpoints that have been reached
         * If we are on lg, all the previous breakpoints and the current one will be returned
         */
        appliedBreakpoints(state) {
            if (state.currentBreakpoint === null) {
                return []
            }

            return Object.keys(defaultTheme.screens).slice(
                0,
                Object.keys(defaultTheme.screens).findIndex(
                    (breakpoint) => breakpoint === state.currentBreakpoint
                ) + 1
            )
        },
    },

    actions: {
        updateScreenSize() {
            this.width = window.innerWidth
            this.height = window.innerHeight

            let currentBreakpoint
            for (const [key, value] of Object.entries(defaultTheme.screens)) {
                if (this.width >= value.split('px')[0]) {
                    currentBreakpoint = key
                }
            }

            this.currentBreakpoint = !!currentBreakpoint
                ? currentBreakpoint
                : null
        },
    },
})
